// extracted by mini-css-extract-plugin
module.exports = {"searchFieldsWrapper":"styles_searchFieldsWrapper__0aAXx"};